export default function MenuService(environment, $http) {
  'ngInject';

  function getMenuTitle() {
    let requestObject = {
      method: "GET",
      url: `${environment.api.baseUrl}/ecourses_menu`
    };
    return $http(requestObject);
  }

  function getViewedNotification() {
    let requestObject = {
      method: "GET",
      url: `${environment.api.baseUrl}/user/notifications`
    };
    return $http(requestObject);
  }

  function postViewedNotification(data) {
    let requestObject = {
      method: 'POST',
      data: data,
      url: `${environment.api.baseUrl}/user/notifications`,
      headers: { 'Content-Type': 'text/plain' },
    };
    return $http(requestObject);
  }

  return {
    getMenuTitle,
    getViewedNotification,
    postViewedNotification
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/services/menuService/menuService.js
 **/